<template>
    <Form :rules="innerRules" populateType="chain" :value="list">
        <field-group
            v-for="(item, index) in list"
            :key="index"
            :model="item"
            class="rent-item"
        >
            <Row :gutter="20">
                <Col span="12">
                    <!-- 第几年 -->
                    <Input
                        v-model="item.year"
                        prop="year"
                        style="display: none"
                    />
                    <span style="position: absolute; top: 0; left: 10px">
                        第{{ item.year }}年涨幅
                    </span>
                    <!-- 涨幅计算类型 -->
                    <FormItem class="rent-field" prop="increaseWay">
                        <Select
                            :disabled="
                                !$can('increase', 'api/contract/info?type=zz')
                            "
                            v-model="item.increaseWay"
                            transfer
                            style="width: 100%; padding-left: 80px"
                        >
                            <Option
                                v-for="v in increaseWayList"
                                :value="v.id"
                                :key="v.id"
                            >
                                {{ v.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <!-- 涨幅值 -->
                    <FormItem class="rent-field" prop="numerical">
                        <input-number
                            v-model="item.numerical"
                            :min="0"
                            :allowNegative="false"
                            :disabled="
                                !$can('increase', 'api/contract/info?type=zz')
                            "
                        >
                            <template #append>
                                {{
                                    item.increaseWay ==
                                    enums.increaseWay.Percent
                                        ? '%'
                                        : '元'
                                }}
                            </template>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
        </field-group>
    </Form>
</template>
<script>
import { Field } from 'ivux'
import Enum from '_u/enum'

const increaseWay = Enum.get('increaseWay')

function createItem(i) {
    return {
        year: i + 2, // 第几年（从第2年开始）
        increaseWay: increaseWay.Percent, // 涨幅方式
        numerical: 0, // 涨幅值
    }
}

// 房间配置
export default {
    name: 'RentIncrease',

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        // 年份跨度
        yearSpan: {
            type: Number,
            default: 0,
            validator(v) {
                return v >= 0
            },
        },
        populateType: {
            type: String,
            default: 'through',
        },
    },

    data() {
        return {
            list: [],
            enums: {
                increaseWay,
            },
        }
    },

    watch: {
        value(val) {
            this.setData(val)
        },
        list: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },
        yearSpan(val) {
            this.setData(this.list)
        },
    },

    computed: {
        innerRules() {
            return {
                // increaseWay: [{ required: true, message: "涨幅方式必填" }],
            }
        },

        increaseWayList() {
            return this.enums.increaseWay.toList()
        },
    },

    created() {
        this.setData(this.value)
    },

    methods: {
        // 初始化数据
        setData(list) {
            var i = list.length
            var j = list.length

            this.list = [...list]

            // 补充空数据
            while (i < this.yearSpan) {
                this.list.push(createItem(i))
                i++
            }
            if (j > this.yearSpan) {
                this.list.splice(this.yearSpan, j - this.yearSpan)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.rent {
    &-item {
        position: relative;
        margin-bottom: 11px;
    }

    &-field {
        flex-basis: 20px;
    }
}
</style>
